import * as Stomp from "stompjs";

import {
    EventEmitter,
    Injectable,
    OnDestroy,
    Output
} from "@angular/core";
import { AppComponent } from "app/app.component";
import { Environment } from "app/decorators/environment.decorator";
import { TenantService } from "app/tenant/tenant.service";
import ReconnectingWebSocket from "reconnecting-websocket";

@Injectable()
export class WebSocketService implements OnDestroy {
    @Output() messageReceived: EventEmitter<any> = new EventEmitter();
    @Output() certificateReceived: EventEmitter<any> = new EventEmitter();
    @Output() totemQuantityReceived: EventEmitter<any> = new EventEmitter();
    @Output() reconnect: EventEmitter<any> = new EventEmitter();
    private hasConnectedOnce = false;
    // baseUrl = 'http://localhost:6379'
    @Environment("baseUrlWs") baseUrl: string;
    webSocketEndPoint: string;
    topic: string = "/topic/reply";
    messageTopic: string = "/topic/message-";
    updateProfileTopic: string = "/topic/updateProfile";
    parateterTopic: string = "/topic/refreshParameter";
    certificateTopic: string = "/topic/certificate";
    totemQuantityTopic: string = "/topic/totemQuantity";

    scheduleDinamicTopic: string = "/topic/refreshSchedule";
    scheduleCalendarDinamicTopic: string = "/topic/refreshScheduleCalendar";

    stompClient: any;
    socket: ReconnectingWebSocket;
    appComponent: AppComponent;

    webSocketeService: WebSocketService;

    tenantService: TenantService;

    subscriptions: { [key: string]: any } = {}; // Armazena as subscrições por tópico

    dinamicSubscriptions: { [key: string]: any } = {}; // Armazena as subscrições por tópico

    private reconnectCount = 0;


    constructor() {
        this.tenantService = new TenantService();
    }
    ngOnDestroy(): void {
        //console.log("web socket disconectado");
        this._disconnect();
    }

    _connect() {
        let token = localStorage.getItem("token");
        let user = JSON.parse(localStorage.getItem("user"));
        if (user == null) {
            setTimeout(() => {
                user = JSON.parse(localStorage.getItem("user"));
            }, 2000);
            if (user == null) {
                return false;
            }
        }
        const tenantPath = this.tenantService.getTenant();

        this.webSocketEndPoint =
            this.baseUrl + tenantPath + "/?X-Auth-Token=" + token;
        this.socket = new ReconnectingWebSocket(this.webSocketEndPoint, [], {
            debug: false,
            minReconnectionDelay: 5000,
            maxReconnectionDelay: 5000,
            reconnectionDelayGrowFactor: 1,
            maxRetries: 10,
        });

        // Adiciona um listener para o evento "open", que é disparado quando a conexão WebSocket é estabelecida com sucesso
        this.socket.addEventListener("open", (event) => {
            console.log("2");
            console.log("Conexão estabelecida com sucesso");
        });

        // Adiciona um listener para o evento "message", que é disparado quando uma mensagem é recebida pelo WebSocket
        this.socket.addEventListener("message", (event) => { });

        // Adiciona um listener para o evento "error", que é disparado quando ocorre algum erro na conexão WebSocket
        this.socket.addEventListener("error", (event) => {
            console.error("Erro na conexão:", event);
            let user = JSON.parse(localStorage.getItem("user"));
            if (user == null) {
                this._disconnect();
            }
        });

        // Adiciona um listener para o evento "close", que é disparado quando a conexão WebSocket é fechada
        this.socket.addEventListener("close", (event) => {
            console.log("Conexão fechada: -----------------");
        });

        this.stompClient = Stomp.over(this.socket);
        this.stompClient.debug = null;
        const _this = this;
        _this.stompClient.connect(
            (user = { user: `${user.id}`, token: token }),
            function (frame) {


                if (_this.hasConnectedOnce) {
                    _this.reconnectCount++;
                    _this.reconnect.emit(_this.reconnectCount);
                    
                }
                _this.hasConnectedOnce = true;


                // Subscribing to various topics using the new method
                _this.subscribeToTopic(_this.topic, tenantPath);

                _this.subscribeToTopic(
                    _this.messageTopic + user.user,
                    tenantPath,
                );

                _this.subscribeToTopic(_this.updateProfileTopic, tenantPath);
                _this.subscribeToTopic(_this.parateterTopic, tenantPath);

                // Reinscreva-se em tópicos dinâmicos
                _this.reconnectDynamicSubscriptions();
            },
        );
    }

    reconnectDynamicSubscriptions() {
        const tenantPath = this.tenantService.getTenant();

        // Reinscreva-se em todos os tópicos dinâmicos
        Object.keys(this.dinamicSubscriptions).forEach((topic) => {
            const fullTopic = `${topic}-${tenantPath}`;
            const subscription = this.stompClient.subscribe(
                fullTopic,
                (sdkEvent) => {
                    this.onMessageReceived(sdkEvent);
                },
            );
            this.dinamicSubscriptions[topic] = subscription; // Atualize a referência da subscrição
            //console.log(`Reconnected to ${fullTopic}`);
        });
    }

    subscribeToTopic(topic: string, tenantPath: string) {
        console.log("Subscribing to topic:", topic);
        console.log("Tenant path:", tenantPath);
        const fullTopic = `${topic}-${tenantPath}`;
        const subscription = this.stompClient.subscribe(
            fullTopic,
            (sdkEvent) => {
                this.onMessageReceived(sdkEvent);
            },
        );
        this.subscriptions[fullTopic] = subscription; // Armazena a subscrição
        //  console.log(`Subscribed to ${fullTopic}`);
    }

    unsubscribeTopic(topic: string, tenantPath: string) {
        // Limpa todas as subscrições armazenadas
        const fullTopic = `${topic}-${tenantPath}`;
        // console.log(this.subscriptions);
        const subscription = this.subscriptions[fullTopic];
        if (subscription) {
            subscription.unsubscribe(); // Cancela a subscrição
            delete this.subscriptions[fullTopic]; // Remove a referência armazenada
            console.log(`Unsubscribed from ${fullTopic}`);
        } else {
            console.log(`No subscription found for ${fullTopic}`);
        }
    }

    subscribeSchedule() {
        const tenantPath = this.tenantService.getTenant();
        this.dinamicSubscriptions[this.scheduleDinamicTopic] = true; // Marque como ativo
        this.subscribeToTopic(this.scheduleDinamicTopic, tenantPath);
    }

    unsubscribeSchedule() {
        const tenantPath = this.tenantService.getTenant();
        delete this.dinamicSubscriptions[this.scheduleDinamicTopic]; // Remova a marcação
        this.unsubscribeTopic(this.scheduleDinamicTopic, tenantPath);
    }

    subscribeCerfificate() {
        let user = JSON.parse(localStorage.getItem("user"));
        const tenantPath = user.id + "-" + this.tenantService.getTenant();
        this.dinamicSubscriptions[this.certificateTopic] = true; // Marque como ativo
        this.subscribeToTopic(this.certificateTopic, tenantPath);
    }

    unsubscribeCerfificate() {
        let user = JSON.parse(localStorage.getItem("user"));
        const tenantPath = this.tenantService.getTenant();
        delete this.dinamicSubscriptions[this.certificateTopic + "-" + user.id]; // Remova a marcação
        this.unsubscribeTopic(
            this.certificateTopic + "-" + user.id,
            tenantPath,
        );
    }

    subscribeScheduleCalendar() {
        const tenantPath = this.tenantService.getTenant();
        this.dinamicSubscriptions[this.scheduleCalendarDinamicTopic] = true; // Marque como ativo
        this.subscribeToTopic(this.scheduleCalendarDinamicTopic, tenantPath);
    }

    unsubscribeScheduleCalendar() {
        const tenantPath = this.tenantService.getTenant();
        delete this.dinamicSubscriptions[this.scheduleCalendarDinamicTopic]; // Remova a marcação
        this.unsubscribeTopic(this.scheduleCalendarDinamicTopic, tenantPath);
    }

    subscribeTotemQuantity() {
        const tenantPath = this.tenantService.getTenant();
        this.dinamicSubscriptions[this.totemQuantityTopic] = true; // Marque como ativo
        this.subscribeToTopic(this.totemQuantityTopic, tenantPath);
    }

    unsubscribeTotemQuantity() {
        const tenantPath = this.tenantService.getTenant();
        delete this.dinamicSubscriptions[this.totemQuantityTopic]; // Remova a marcação
        this.unsubscribeTopic(this.totemQuantityTopic, tenantPath);
    }

    _disconnect() {
        if (this.stompClient !== null) {
            // this.socket.close();
            const tenantPath = this.tenantService.getTenant();
            let simpDisconectMessage;
            this.stompClient?.disconnect(
                null,
                (simpDisconectMessage = { tenant: tenantPath }),
            );
            console.log("87 web socket disconectado");
            if (this.socket) {
                this.socket.close(); // Fecha a conexão e impede nova tentativa de reconexão
                this.socket = null;
            }
            this.stompClient = null;
            delete this.stompClient;
            delete this.socket;
        }
    }

    // on error, schedule a reconnection attempt
    errorCallBack() {
        this.stompClient.onWebSocketClose = (e) => { };
    }

    _send(message) { }

    onMessageReceived(message) {
        let token = localStorage.getItem("token");
        if (token) {
            this.messageReceived.emit(message);
            if (message?.headers?.destination?.includes("certificate")) {
                this.onMessageReceivedCertificate(message);
                return;
            } if (message?.headers?.destination?.includes("totemQuantity")) {
                this.onMessageReceivedTotemQuantity(message);
                return;
            } else {
                this.messageReceived.emit(message);
            }
        } else if (message.body != "EXPIREPASSWORD") {
            this._disconnect();
        }
    }

    onMessageReceivedCertificate(message) {
        this.certificateReceived.emit(message);
    }

    onMessageReceivedTotemQuantity(message) {
        this.totemQuantityReceived.emit(message);
    }


    scheduleView(message) {
        let token = localStorage.getItem("token");
        if (token) {
            this.messageReceived.emit(message);
        }
    }
}
